import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getClasses, bookClass, cancelBooking } from "./maxClassScheduleSlice";
import moment from "moment";

//CSS & Bootstrap imports
import classes from "./MaxClassSchedule.module.css";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Table from "react-bootstrap/Table";

import data from "./placeHolderData";

const MaxClassSchedule = () => {
  const dispatch = useDispatch();
  const classList = useSelector((state) => state.maxClassSchedule.classList);
  const classListStatus = useSelector(
    (state) => state.maxClassSchedule.classListStatus
  );
  const bookingStatus = useSelector(
    (state) => state.maxClassSchedule.bookingStatus
  );

  const [scheduleData, setScheduleData] = useState([]);
  const [calendarDate, setCalendarDate] = useState("");

  // Getting all class schedule data
  useEffect(() => {
    dispatch(getClasses());
    setCalendarDate(new Date());
  }, []);

  useEffect(() => {
    if (classList) {
      setScheduleData(classList);
    }
  }, [classList]);

  useEffect(() => {
    if (calendarDate != "")
      dispatch(
        getClasses({ from_date: moment(calendarDate).format("YYYY-MM-DD") })
      );
  }, [calendarDate]);

  useEffect(() => {
    if (bookingStatus == "idle") {
      setShowDescModal(false);
    }
  }, [bookingStatus]);

  //Book Button
  const BookButton = (classData, inModal) => {
    if (classData.IsBooked) {
      return (
        <button
          className={
            bookingStatus == "fetching"
              ? classes.BookButtonDisabled
              : classes.BookButton
          }
          disabled={bookingStatus == "fetching"}
          onClick={() =>
            dispatch(cancelBooking({ class_schedule_id: classData.ScheduleId }))
          }
          style={
            inModal
              ? {
                  borderRadius: "0px",
                  lineHeight: "16px",
                  fontSize: "16px",
                  borderRadius: "10px",
                }
              : null
          }
        >
          Cancel {classData.booking_status == 2 ? "Wait Listing" : "Booking"}
        </button>
      );
    } else {
      return classData.BookingAllowed ? (
        <>
          <div style={inModal ? { fontSize: "16px" } : {fontSize: "12px"}}>
            {classData.FreeSpots > 0
              ? `${classData.FreeSpots} spots open`
              : "Class full"}
          </div>
          <button
            className={
              bookingStatus == "fetching"
                ? classes.BookButtonDisabled
                : classes.BookButton
            }
            onClick={() =>
              dispatch(bookClass({ class_schedule_id: classData.ScheduleId }))
            }
            disabled={bookingStatus == "fetching"}
            style={
              inModal
                ? {
                    borderRadius: "0px",
                    lineHeight: "16px",
                    fontSize: "16px",
                    borderRadius: "10px",
                  }
                : null
            }
          >
            {classData.FreeSpots > 0 ? (
              "Book Now"
            ) : (
              <span className={classes.WaitListText}>Add to waitlist</span>
            )}
          </button>
        </>
      ) : new Date(classData?.Date?.replace(/-/g, '\/')) > Date.now() ? (
        <span className={classes.ItalicizeText} style={{ fontSize: "12px" }}>
          Cannot book more than 7 days in advance
        </span>
      ) : (
        <span className={classes.ItalicizeText}>Date has passed</span>
      );
    }
  };

  //   Description Modal Variables
  const [classDesc, setClassDesc] = useState({});
  const [showDescModal, setShowDescModal] = useState(false);
  const handleCloseDescModal = () => setShowDescModal(false);
  const handleShowDescModal = () => setShowDescModal(true);

  const getClassesOnDate = (date) => {
    let classesThisDate = scheduleData.filter((classData) => {
      return classData.Date == date;
    });
    return classesThisDate.length > 0 ? (
      classesThisDate.map((classData) => (
        <tr>
          <td>{classData.StartTime}</td>
          <td
            style={{ color: "#2a80b9", cursor: "pointer" }}
            onClick={() => {
              setClassDesc(classData);
              setShowDescModal(true);
            }}
          >
            {classData.Title}
          </td>
          <td className={classes.InstructorBlock}>
            {classData.InstructorId ? (
              `${classData.InstructorFirstName} ${classData.InstructorLastName}`
            ) : (
              <p className={classes.ItalicizeText}>No Instructor Yet</p>
            )}
          </td>
          <td>{BookButton(classData)}</td>
          <td>{classData.duration} minutes</td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan={5}>
          <span className={classes.ItalicizeText}>No Classes This Day</span>
        </td>
      </tr>
    );
  };

  //   const addDate = (date, val) => {
  //     return moment(date).add(val, "d").format("MM-DD-YYYY");
  //   };
  return (
    <div className={classes.MainBody}>
      <div className={classes.TopBlock}>
        <div className={classes.TopButtonBlock}>
          <span
            style={{ cursor: "pointer", fontSize: "18px" }}
            onClick={() => {
              let currDate = new Date(calendarDate);
              currDate.setDate(currDate.getDate() - 7);
              setCalendarDate(currDate);
            }}
          >
            <i class="fas fa-caret-left"></i>
          </span>
          <span style={{ margin: "0px 20px" }}>Week</span>
          <span
            style={{ cursor: "pointer", fontSize: "18px" }}
            onClick={() => {
              let currDate = new Date(calendarDate);
              currDate.setDate(currDate.getDate() + 7);
              setCalendarDate(currDate);
            }}
          >
            <i class="fas fa-caret-right"></i>
          </span>
        </div>
        <input
          type="date"
          id="date-picker"
          name="class-date-picker"
          onChange={(e) => setCalendarDate(e.target.value)}
          value={moment(calendarDate).format("YYYY-MM-DD")}
        ></input>
      </div>
      {classListStatus == "idle" ? (
        classList && classList?.length > 1 ? (
          <Table bordered hover striped>
            <thead style={{ backgroundColor: "#ccc" }}>
              <tr>
                <th style={{ width: "15%" }}>Start Time</th>
                <th>Class Name</th>
                <th className={classes.InstructorBlock}>Instructor</th>
                <th>Availability</th>
                <th>Duration</th>
              </tr>
            </thead>
            <tbody>
              {[...Array(7).keys()].map((val) => {
                return (
                  <>
                    <tr>
                      <td colSpan={5} style={{ backgroundColor: "#e0e0e0" }}>
                        <span className={classes.DateHeader}>
                          {moment(calendarDate)
                            .add(val, "d")
                            .format("ddd MMMM D[,] YYYY")}

                          {(moment(calendarDate).add(val, "d").day() == 0 ||
                            moment(calendarDate).add(val, "d").day() == 6) && (
                            <span
                              style={{ marginLeft: 10, fontWeight: "bold" }}
                            >
                              Closed
                            </span>
                          )}
                        </span>
                      </td>
                    </tr>
                    {getClassesOnDate(
                      moment(calendarDate).add(val, "d").format("MM-DD-YYYY")
                    )}
                  </>
                );
              })}
            </tbody>
          </Table>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "25px",
            }}
          >
            Schedule data is not currently available
          </div>
        )
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spinner
            animation="border"
            role="status"
            style={{ color: "#961A1D" }}
          >
            <span className="sr-only">Loading...</span>
          </Spinner>
        </div>
      )}

      {/* Description Modal */}
      <Modal show={showDescModal} onHide={handleCloseDescModal}>
        <Modal.Body>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                color: "#555459",
                backgroundColor: "#E2E2E2",
                textAlign: "center",
                padding: "20px",
                marginBottom: 20,
              }}
            >
              <p>{classDesc.Title}</p>
              <p>
                {classDesc.StartTime} - {classDesc.EndTime}
              </p>
              <p>{moment(classDesc.Date).format("dddd[,] MMMM D[,] YYYY")}</p>
            </div>
            {classDesc.InstructorId && (
              <div style={{ marginBottom: 20 }}>
                Instructor: {classDesc.InstructorFirstName}{" "}
                {classDesc.InstructorLastName}
              </div>
            )}
            <div style={{ marginBottom: 20 }}>
              {classDesc.Description
                ? classDesc.Description
                : "There is no class description available for this class"}
            </div>

            {BookButton(classDesc, true)}
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDescModal}>
            Close
          </Button>
          <Button variant="primary" onClick={handleCloseDescModal}>
            Confirm
          </Button>
        </Modal.Footer> */}
      </Modal>
    </div>
  );
};

export default MaxClassSchedule;
